export interface SelectionPricingInput {
  unitPrice?: number | null
  quantity?: number | null
  baseUnitPrice?: number | null
  priceDelta?: number | null
}

export interface SelectionPricingSummary {
  quantity: number
  selectedTotal: number | null
  baseTotal: number | null
  perUnitDelta: number | null
  totalDelta: number | null
}

export function resolveSelectionPricing(input: SelectionPricingInput): SelectionPricingSummary {
  const quantity = typeof input.quantity === 'number' && input.quantity > 0 ? input.quantity : 1
  const hasUnitPrice = typeof input.unitPrice === 'number'
  const hasBaseUnitPrice = typeof input.baseUnitPrice === 'number'
  const hasExplicitDelta = typeof input.priceDelta === 'number'

  const selectedTotal = hasUnitPrice ? input.unitPrice! * quantity : null
  const baseTotal = hasBaseUnitPrice ? input.baseUnitPrice! * quantity : null

  const perUnitDelta = hasExplicitDelta
    ? input.priceDelta!
    : hasUnitPrice && hasBaseUnitPrice
      ? input.unitPrice! - input.baseUnitPrice!
      : null

  const totalDelta = perUnitDelta !== null
    ? perUnitDelta * quantity
    : selectedTotal !== null && baseTotal !== null
      ? selectedTotal - baseTotal
      : null

  return {
    quantity,
    selectedTotal,
    baseTotal,
    perUnitDelta,
    totalDelta,
  }
}
